<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    :scroll="{ x: 1530 }"
    class="mb40"
    :pagination="pagination"
  >
    <template v-slot:bodyCell="{ column, record }">
      <template v-if="column.dataIndex == 'status'">
        {{ record.status === 1 ? '直播中' : '未直播' }}
      </template>
      <template v-if="column.dataIndex == 'pdp'">
        <a-popconfirm title="Sure to update?" @confirm="handleOpen(record)">
          <a-switch
            v-model:checked="record.pdp"
            :checkedValue="1"
            :unCheckedValue="0"
            checked-children="开"
            un-checked-children="关"
          />
        </a-popconfirm>
      </template>
      <template v-if="column.dataIndex == 'collection'">
        <a-popconfirm title="Sure to update?" @confirm="handleOpen(record)">
          <a-switch
            v-model:checked="record.collection"
            :checkedValue="1"
            :unCheckedValue="0"
            checked-children="开"
            un-checked-children="关"
          />
        </a-popconfirm>
      </template>
      <template v-if="column.dataIndex == 'specialPage'">
        <a-popconfirm title="Sure to update?" @confirm="handleOpen(record)">
          <a-switch
            v-model:checked="record.specialPage"
            :checkedValue="1"
            :unCheckedValue="0"
            checked-children="开"
            un-checked-children="关"
          />
        </a-popconfirm>
      </template>
      <template v-if="column.dataIndex == 'home'">
        <a-popconfirm title="Sure to update?" @confirm="handleOpen(record)">
          <a-switch
            v-model:checked="record.home"
            :checkedValue="1"
            :unCheckedValue="0"
            checked-children="开"
            un-checked-children="关"
          />
        </a-popconfirm>
      </template>
      <template v-if="column.dataIndex == 'operate'">
        <a-button type="link" @click="handleEdit(record)">
          编辑
        </a-button>
        <a-popconfirm title="确定删除吗?" @confirm="handleDel(record)">
          <a-button type="link">
            删除
          </a-button>
        </a-popconfirm>
      </template>
    </template>
  </a-table>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped></style>
